import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { ILogin } from "../models/ICommon";
import { loginUser } from "../action/common/keyClaokActionCreator";
import { getCurrentUserData } from "../action/user/userProfileActionCreator";
import { UserRole } from "../constants/RoleEnum";
import { ROUTER_URL } from "../constants/routerUrl";
import { useNavigate } from "react-router-dom";
import LoaderSpinner from "../common-components/loader";
import { getAiAgentKey, getPreviousChatMessage } from "../action/ai/aiConfigurationActionCreator";
import { limit } from "../constants/pageBlocks";

const Login = (props: ILogin) => {
  const { getUserDetails, getCurrentRole, currentRole, isAuthenticated, getAIPreviousChatMessage, fetchAiAgentKey } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowPassword(event.target.checked);
  };

  const handlePasswordPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
  };

  const navigate = useNavigate();
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(true);
  const [token] = useState<string | null>(localStorage.getItem("token"))

  const NavigateToLandingPage = () => {
    if (currentRole === UserRole.SuperAdmin) {
      navigate(ROUTER_URL.COLLEGE_INDEX);
    } else if (currentRole === UserRole.CollegeAdmin) {
      navigate(ROUTER_URL.COLLEGE_DETAILS);
    } else if (currentRole === UserRole.DepartmentAdmin) {
      navigate(ROUTER_URL.DEPARTMENT_DETAILS);
    } else if (currentRole === UserRole.Staff) {
      navigate(ROUTER_URL.STAFF_DASHBOARD);
    } else if (currentRole === UserRole.Faculty) {
      navigate(ROUTER_URL.FACULTY_DASHBOARD);
    } else if (currentRole === UserRole.Student) {
      navigate(ROUTER_URL.STUDENT_DASHBOAD);
    }
  };

  useEffect(() => {
    const mainTag = document.querySelector('main');
    if (UserRole === undefined) {
      setLoader(false)
    }
    if (mainTag) {
      mainTag.classList.add('main-login');
      document.body.style.backgroundImage = "url('/assets/images/about_andrews.jpg')";
    }

    return () => {
      if (mainTag) {
        mainTag.classList.remove('main-login');
        document.body.style.backgroundImage = "url('/assets/images/bg/abstract.jpg')";
      }
    };
  }, []);

  useEffect(() => {
    setLoader(false);
    token && getUser();
  }, [])

  useEffect(() => {
    currentRole && NavigateToLandingPage()
  }, [currentRole])

  const getUser = async () => {
    setLoader(true);
    try {
      await getCurrentRole();
      fetchAiAgentKey();
      getAIPreviousChatMessage(limit.five);
    } finally {
      setLoader(false);
    }
  };

  const login = async () => {
    setLoader(true);
    await getUserDetails(username, password, getUser, setLoader);
  };



  return (
    <>
      {loader ? <LoaderSpinner /> : (
        <div className="login-contents">
          <div className="content-center">
            <div className="topban">
              <div className="toplogo">
                <div className="logo">
                  <img src="/assets/images/andrew-logo.png" alt="" />
                </div>
              </div>
              <img src="/assets/images/login.jpg" alt="" />
            </div>
            <div className="col-lg-12">
              <div className="mb-3">
                <h3 className="text-dark">Welcome to My Andrews</h3>
              </div>
              <form action="#" method="post">
                <div className="form-group">
                  <label>Username</label>
                  <input
                    onChange={(event) => setUsername(event.target.value.replace(/\s+/g, ''))}
                    value={username}
                    type="text"
                  />
                </div>
                <div className="form-group showpassword">
                  <label>Password</label>
                  <input
                    onChange={(event) => setPassword(event.target.value.replace(/\s+/g, ''))}
                    value={password}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        login();
                      }
                    }}
                    onPaste={handlePasswordPaste}
                  />
                  <div>
                    <input type="checkbox" id="toggle-password" onChange={handleCheckboxChange} />
                    <label htmlFor="toggle-password">
                      <i className="fas fa-eye" style={{ color: "#999999" }}></i>
                    </label>
                  </div>
                </div>
                <a
                  className="btn btn-primary btn-grad"
                  id="login-btn"
                  onClick={login}
                  aria-disabled={loader}
                >
                  Log In
                </a>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = {
  getUserDetails: (username: string, password: string, callBack: Function, setLoader: Function) =>
    loginUser(username, password, callBack, setLoader),
  getCurrentRole: () => getCurrentUserData(),
  getAIPreviousChatMessage: (limit: number) => getPreviousChatMessage(limit),
  fetchAiAgentKey: () => getAiAgentKey(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    isAuthenticated: state.userDetails.isAuthenticated,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
